import React, { useContext } from "react";
import { ButtonLink } from "dyl-components";
import { Checkbox, Popup } from "semantic-ui-react";
import { BulkActionsContext } from "shared/context/BulkActionsProvider";

export default function SelectAllCheckbox({
    count,
    data,
    type,
    idProperty,
    onSelectAll = () => {},
    isDisabled = false,
    isModal,
    location = 'System',
    position = 'top left'
}) {
    const [
        selectedData,
        setSelectedData,
        areDataInAllPagesSelected,
        setAreDataInAllPagesSelected,
    ] = useContext(BulkActionsContext);

    const onToggleAreDataInAllPagesSelected = () => {
        setAreDataInAllPagesSelected(!areDataInAllPagesSelected);
    };
    
    const selectableData = data.filter((record) => !record.isDisabled);

    const selectableIds = selectableData.map(
        (record) => record[idProperty]
    );


    const onToggleAll = () => {
        const areAllSelected =
            selectableIds.length > 0 &&
            selectableIds.every((id) => selectedData.includes(id));

        const newSelectedData = areAllSelected
            ? selectedData.filter((id) => !selectableIds.includes(id))
            : [
                ...new Set([
                    ...selectedData,
                    ...selectableIds,
                ]),
            ];

        setSelectedData(newSelectedData);
        onSelectAll(newSelectedData);
        setAreDataInAllPagesSelected(false);
    };

    const areAllSelected =
        selectableIds.length > 0 &&
        selectableIds.every((id) => selectedData.includes(id));

    const areDataPartiallySelected =
        selectableIds.some((id) => selectedData.includes(id)) &&
        !areAllSelected;

    return (
        <Popup
            {...(areAllSelected ? { style: { zIndex: !isModal ? 9 : 9999 } } : {})}
            position={position}
            open={areAllSelected}
            trigger={
                <Checkbox
                    checked={areAllSelected}
                    onClick={!isDisabled && onToggleAll}
                    indeterminate={areDataPartiallySelected}
                    disabled={isDisabled}
                />
            }
            content={
                <div
                    style={{
                        width: areDataInAllPagesSelected ? "24em" : "34em",
                    }}
                >
                    All{" "}
                    {areDataInAllPagesSelected
                        ? `${count} ${type} in ${location} selected.`
                        : `${data.length} ${type} on this page selected.`}{" "}
                    <ButtonLink
                        onClick={onToggleAreDataInAllPagesSelected}
                        noPadding
                    >
                        {areDataInAllPagesSelected
                            ? "Undo Selection."
                            : `Select ${count} ${type} on all Pages.`}
                    </ButtonLink>
                </div>
            }
        />
    );
}
